import { observer } from "mobx-react";
import { IApplicationFilterComponent } from "../BaseFilterComponents/IApplicationFilterComponent";
import { Grid, Stack } from "@mui/material";
import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { EvaluationType } from "stores/ApplicationFilters/Filters/EvaluationType";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useStore } from "utils/useStore";
import { AuthStore } from "stores/AuthStore";
import { useOptionRestriction } from "../BaseFilterComponents/useRestrictedOptions";
import { usePruneSelectedValues } from "../BaseFilterComponents/usePruneSelectedValues";

export const EvaluationTypesFilter = observer(function (
    props: IApplicationFilterComponent,
) {
    const authStore = useStore(AuthStore);
    const { isValueAllowed: isAllowed } = useOptionRestriction({
        optionRestriction: props.optionRestriction,
        restrictedValues: props.restrictedValues,
    });

    usePruneSelectedValues({
        selectedValues: props.store.evaluationTypes,
        setSelectedValues: (values) => props.store.setEvaluationTypes(values),
        isValueAllowed: isAllowed,
    });

    if (
        authStore.canUserView("Restrict Evaluations") &&
        !authStore.isUserUltra()
    ) {
        return null;
    }
    return (
        <Stack>
            <FormControlLabel
                label={
                    <Grid container alignItems="center">
                        No Evaluation
                    </Grid>
                }
                control={
                    <Checkbox
                        id="application-filters-eval-type-no-evaluation"
                        onChange={() => {
                            if (!isAllowed(EvaluationType.NotEvaluated)) return;
                            props.store.toggleEvaluationType(
                                EvaluationType.NotEvaluated,
                            );
                        }}
                        checked={props.store.evaluationTypes.includes(
                            EvaluationType.NotEvaluated,
                        )}
                        disabled={!isAllowed(EvaluationType.NotEvaluated)}
                    />
                }
                sx={{ maxHeight: "28px" }}
            />
            <FormControlLabel
                label={
                    <Grid container alignItems="center">
                        AI Evaluated
                        <Grid item style={{ paddingLeft: "4px" }}>
                            <CheckCircleOutlineIcon
                                color={"primary"}
                                style={{
                                    width: "16px",
                                    height: "16px",
                                    float: "right",
                                }}
                            />
                        </Grid>
                    </Grid>
                }
                control={
                    <Checkbox
                        id="application-filters-eval-type-AI-evaluated"
                        onChange={() => {
                            if (!isAllowed(EvaluationType.AIEvaluated)) return;
                            props.store.toggleEvaluationType(
                                EvaluationType.AIEvaluated,
                            );
                        }}
                        checked={props.store.evaluationTypes.includes(
                            EvaluationType.AIEvaluated,
                        )}
                    />
                }
                sx={{ maxHeight: "28px" }}
                disabled={
                    !isAllowed(EvaluationType.AIEvaluated) ||
                    props.store.evaluationTypes.includes(
                        EvaluationType.NotEvaluated,
                    )
                }
            />
            <FormControlLabel
                label={
                    <Grid container alignItems="center">
                        Human Evaluated
                        <Grid item style={{ paddingLeft: "4px" }}>
                            <CheckCircleOutlineIcon
                                color={"secondary"}
                                style={{
                                    width: "16px",
                                    height: "16px",
                                    float: "right",
                                }}
                            />
                        </Grid>
                    </Grid>
                }
                control={
                    <Checkbox
                        id="application-filters-eval-type-human-evaluated"
                        onChange={() => {
                            if (!isAllowed(EvaluationType.HumanEvaluated))
                                return;
                            props.store.toggleEvaluationType(
                                EvaluationType.HumanEvaluated,
                            );
                        }}
                        checked={props.store.evaluationTypes.includes(
                            EvaluationType.HumanEvaluated,
                        )}
                    />
                }
                sx={{ maxHeight: "28px" }}
                disabled={
                    !isAllowed(EvaluationType.HumanEvaluated) ||
                    props.store.evaluationTypes.includes(
                        EvaluationType.NotEvaluated,
                    )
                }
            />
        </Stack>
    );
});
